const fourFiveSchema = {
  title:
    "4_5 Use of Services not Described in the above sub-categories by an Organization",
  addAPI: "cat4_5AddEmissionActivityAPI",
  cat: "cat4_5",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Purchased Goods Name / Model No.",
      resetOnChange: false,
      required: true,
    },
  ],
};

export default fourFiveSchema;
